export const getPolicyRuleItems = policyRulesData => {
  if (!policyRulesData) return []

  return policyRulesData?.map(rule => ({
    value: rule.id,
    label: `#${rule.internal_id} | ${rule.name}`,
  }))
}
